<template>
  <div style="height: 95vh !important"></div>
</template>

<script>
import { ErrorAlertHandler } from "@/utils/errorAlert/ErrorAlert.js";
import { checkNotEmpty } from "@/utils/popup/common.js";
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      user: {},
      authorizationCode: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      urlapi: process.env.VUE_APP_APIURL,
      imgSwalErr: require("@/assets/images/ic_swal_error_reject.png"),
    };
  },
  created() {
    try {
      // console.log(this.$route);
      this.initDataCallFromNext();
    } catch (error) {
      this.handdleError(error);
    }
  },
  methods: {
    initDataCallFromNext() {
      this.authorizationCode = this.$route.query.authorizationCode;
      const viewOnly = this.$route.query.viewOnly;
      const redirect = this.$route.query.redirect;
      //Get data by token
      this.$http({
        method: "POST",
        url: this.urlapi + "api/verifyToken",
        data: {
          authorizationCode: this.authorizationCode,
          redirect: redirect,
        },
        timeout: this.timeout,
      })
        .then((response) => {
          this.mappingDataResponse(response, viewOnly);
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    async mappingDataResponse(response, viewOnly) {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf("android") > -1;
      // console.log("isAndroid", isAndroid);
      if (response.data && response.data.status) {
        this.user.cif = response.data.cifNumber;
        this.user.creditLimit = Number(response.data.reqCreditLimit);
        this.user.documentType = response.data.documentType;
        this.user.historyUploads = response.data.checkListDocUploads;
        this.user.followupStatus = response.data.followupStatus;
        this.user.fullName = response.data.fullName;
        this.user.expiredDate = response.data.expiredDate;
        this.user.expireDay = response.data.expireDay;
        this.user.showDStatement = response.data.showDStatement;
        this.user.showDStatementErrorMsg = response.data.showDStatementErrorMsg;
        this.user.lstPriceAs = response.data.lstPriceAs;
        this.user.isAndroid = isAndroid;
        this.user.loanAppId = response.data.loanAppId;
        this.user.productName = response.data.paramDesc;
        this.user.productType = response.data.productType;
        this.user.haveListAccount = response.data.haveAccountList;
        this.user.marketCode = response.data.marketCode;
        this.user.periodStatementKtb = response.data.periodStatementKtb;
        this.user.periodStatementOtherBanks =
          response.data.periodStatementOtherBanks;
        this.user.otherBankHistory = response.data.otherBankHistory;
        this.user.monthCalc = response.data.monthCalc;
        this.user.isDocumentType = ["PENDING", "SUBMITED", "RESUBMIT"].includes(
          response.data.followupStatus.code
        );
        this.user.token = response.data.uuid;
        this.user.accessToken = this.$route.query.authorizationCode;
        this.user.channel =
          response.data.channel &&
            "PT" == response.data.channel.toString().toUpperCase()
            ? "Paotang"
            : "NEXT";
        this.user.document_group_type = response.data.documentTypeGroup;
        this.user.document_group_type.forEach((v) => {
          v.progress = 0;
          let arry = this.user.documentType.filter(
            (docType) =>
              v.lst_doc_id.includes(docType.doc_code) && docType.doc_is_uploads
          );
          v.state = "wait";
          if (arry.length === v.lst_doc_id.length) v.state = "success";
        });
        this.user.documentType.forEach((i) => {
          i.filesReal = [];
          i.state = "wait";
          if (i.doc_is_uploads) i.state = "success";
          i.collapse = true;
          if (i.example_doc == null || !i.example_doc) {
            i.example_doc = [];
          }
        });
        this.setRoutePath();
        this.user.listener = {
          landing: true,
        };
        const listAccount = await this.getAccountCBS(this.user.document_group_type, this.user.token);
        // console.log("listAccount", listAccount);
        this.user.listAccount = listAccount;
        this.$store.dispatch("setUserData", this.user);
        if (viewOnly === "true") {
          this.$router.push("/example-doc");
        } else {
          this.$router.push("/landing");
        }
      }
    },
    setRoutePath() {
      this.user.routerPath = {
        landing: "MainPage",
        login: "LoginPage",
        upload: "UploadPage",
        summary: "SummaryPage",
        documentGroup: "DocumentGroupPage",
        listAccount: "ListAccountPage",
        dStatement: "DstatementPage",
        uploadOtherBanks: "UploadOtherBanksPage",
        uploadOtherBank: "UploadOtherBankPage",
        statement: "StatementPage",
        preupload: "PreUploadPage",
      };
    },
    handdleError(error) {
      ErrorAlertHandler(error, "0", this);
    },
    async getAccountCBS(document_group_type, token) {
      let grp01 = document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }
      const axiosInstance = axios.create({
        baseURL: this.urlapi,
        timeout: this.timeout,
        headers: { Authorization: token },
      });
      axiosInstance.interceptors.request.use(
        function (config) {
          return config;
        },
        function (error) {
          fnSet(false);
          // Do something with request error
          return Promise.reject(error);
        }
      );
      axiosInstance.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          return Promise.reject(error);
        }
      );
      let listAccount = await axiosInstance({
        method: "GET",
        url: "/api/accountInfo?docIdStatement=" + docIdStatement,
      })
        .then((response) => {
          const listAccount = response.data.filter(
            (item) => !checkNotEmpty(item.errorMsg)
          );
          return listAccount;
        })
        .catch((error) => {
          console.error("Error account info", error);
          ErrorAlertHandler(error, "1", this);
          return [];
        });
      // console.log("listAccount", listAccount);
      return listAccount;
    }
  },
};
</script>

<style>
.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 40vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}

.swal2-image-next-fullscreen {
  margin-top: 0vh !important;
  margin-bottom: 0vh !important;
}

.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}

.swal2-icon-content {
  margin: 0;
  font-family: Kanit-Bold;
  font-size: 20px !important;
  line-height: 24px !important;
  color: #212121 !important;
}

.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}

.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}
</style>
